// Focus Management for Overlays and Modals
document.addEventListener('DOMContentLoaded', function() {
  
  // Track the element that opened a modal (so we can return focus later)
  let focusedElementBeforeModal;
  
  // List of overlay/drawer components to manage
  const overlaySelectors = [
    'overlay-component',
    'cart-drawer',
    'search-drawer',
    'menu-drawer',
    'collection-drawer',
    'drawer-inner'
  ];
  
  overlaySelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    
    elements.forEach(overlay => {
      // When overlay becomes visible
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          const isVisible = !overlay.classList.contains('hidden') && 
                           !overlay.getAttribute('aria-hidden') === 'true';
          
          if (isVisible) {
            // Save currently focused element
            focusedElementBeforeModal = document.activeElement;
            
            // Move focus into the overlay
            const focusableElements = overlay.querySelectorAll(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            
            if (focusableElements.length > 0) {
              focusableElements[0].focus();
            }
            
            // Trap focus: prevent Tab from leaving the overlay
            overlay.addEventListener('keydown', trapFocus);
            
            // Make sure overlay and its contents are visible to keyboard
            overlay.removeAttribute('aria-hidden');
            overlay.style.visibility = 'visible';
            
          } else {
            // When overlay closes, return focus
            overlay.removeEventListener('keydown', trapFocus);
            
            if (focusedElementBeforeModal) {
              focusedElementBeforeModal.focus();
              focusedElementBeforeModal = null;
            }
          }
        });
      });
      
      observer.observe(overlay, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });
    });
  });
  
  // Trap focus within modal/overlay
  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    
    const overlay = e.currentTarget;
    const focusableElements = Array.from(overlay.querySelectorAll(
      'button:not([disabled]), [href]:not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(el => {
      return el.offsetParent !== null; // Only visible elements
    });
    
    if (focusableElements.length === 0) return;
    
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    
    // If Shift+Tab at the beginning, go to end
    if (e.shiftKey && document.activeElement === firstElement) {
      e.preventDefault();
      lastElement.focus();
    }
    // If Tab at the end, go to beginning
    else if (!e.shiftKey && document.activeElement === lastElement) {
      e.preventDefault();
      firstElement.focus();
    }
  }
  
  // Ensure focus indicators are always visible
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Tab') {
      document.body.classList.add('keyboard-focused');
    }
  });
  
  document.addEventListener('mousedown', function() {
    document.body.classList.remove('keyboard-focused');
  });
});